import { call, take, put, takeLatest } from 'redux-saga/effects';
import { get, putMethod, deleteMethod, post } from '../../utils/api';
import settings from '../../utils/settings';

import {
  GET_AREA_COVERAGE_REQUEST,
  GET_AREA_COVERAGE_SUCCESS,
  GET_AREA_COVERAGE_FAILURE,
  GET_COUNTIES_REQUEST,
  GET_COUNTIES_SUCCESS,
  ADD_AREA_COVERAGE_REQUEST,
  ADD_AREA_COVERAGE_SUCCESS,
  ADD_AREA_COVERAGE_FAILURE,
  DELETE_AREA_COVERAGE_REQUEST,
  DELETE_AREA_COVERAGE_SUCCESS,
  DELETE_AREA_COVERAGE_FAILURE,
  UPDATE_AREA_COVERAGE_REQUEST,
  UPDATE_AREA_COVERAGE_SUCCESS,
  UPDATE_AREA_COVERAGE_FAILURE,
  GET_COVERAGE_STATE_REQUEST,
  GET_COVERAGE_STATE_SUCCESS,
  GET_STATE_COUNTIES_SUCCESS,
  GET_COUNTIES_FAILURE,
  GET_STATE_COUNTIES_FAILURE
} from './constants';

export function* watchLatestCountiesFlow() {
  yield takeLatest(GET_COUNTIES_REQUEST, countiesFlow);
}

export function* countiesFlow(action) {
  const { countyName, isStateCounty = false, countryCode } = action.data;
  try {
    let response;
    const param = isStateCounty ? `state_name=${countyName}` : `county_name=${countyName}`;
    response = yield call(get, {
      url: settings.getApiUrl(`service/enlm_ms/api_internal/installer_area_coverage/counties?${param}&country_code=${countryCode}`)
    });
    if (response.success) {
      const { status, result } = response;
      if (status === 200) {
        isStateCounty
          ? yield put({ type: GET_STATE_COUNTIES_SUCCESS, stateCounties: result })
          : yield put({ type: GET_COUNTIES_SUCCESS, counties: result });
      } else {
        console.log('Saga: countiesFlow :---');
      }
    }
  } catch (error) {
    isStateCounty ? yield put({ type: GET_STATE_COUNTIES_FAILURE }) : yield put({ type: GET_COUNTIES_FAILURE });
    console.log('Saga: countiesFlow :', error);
  }
}

export function* areaCoverageFlow() {
  while (true) {
    const request = yield take(GET_AREA_COVERAGE_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/company/${request.companyId}/zones`)
      });
      const { success, status, result } = response;
      if (success && status === 200) {
        yield put({ type: GET_AREA_COVERAGE_SUCCESS, zones: result });
      } else {
        yield put({ type: GET_AREA_COVERAGE_FAILURE, error: result.message || result.messages });
      }
    } catch (error) {
      yield put({ type: GET_AREA_COVERAGE_FAILURE, error });
    }
  }
}

export function* addAreaCoverageFlow() {
  while (true) {
    const request = yield take(ADD_AREA_COVERAGE_REQUEST);
    const { zone, a, companyId, companyInfo } = request.payload;
    try {
      let response;
      response = yield call(post, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/company/${companyId}/zones`),
        body: { zone, company_info: companyInfo }
      });
      const { success, status, result } = response;
      const { zones, messages, message } = result;
      if (success && status === 200 && result.success) {
        yield put({
          type: ADD_AREA_COVERAGE_SUCCESS,
          zones: zones || [],
          formMessage: messages,
          lastUpdatedZoneName: zone.name
        });
        a();
      } else {
        yield put({ type: ADD_AREA_COVERAGE_FAILURE, formMessage: messages || message });
      }
    } catch (error) {
      yield put({ type: ADD_AREA_COVERAGE_FAILURE, error });
    }
  }
}

export function* deleteAreaCoverageFlow() {
  while (true) {
    const request = yield take(DELETE_AREA_COVERAGE_REQUEST);
    const { zoneId, companyId } = request.payload;
    try {
      let response;
      response = yield call(deleteMethod, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/company/${companyId}/zones/${zoneId}`)
      });
      if (response.success) {
        const { messages, success, zones } = response.result;
        if (success) {
          yield put({ type: DELETE_AREA_COVERAGE_SUCCESS, zones, formMessage: messages });
        } else {
          yield put({ type: DELETE_AREA_COVERAGE_FAILURE, formMessage: messages });
        }
      }
    } catch (error) {
      console.log('Saga: deleteAreaCoverageFlow :', error);
    }
  }
}

export function* updateAreaCoverageFlow() {
  while (true) {
    const request = yield take(UPDATE_AREA_COVERAGE_REQUEST);
    const { zone, zoneId, companyId, successCb, companyInfo } = request.payload;
    try {
      let response;
      response = yield call(putMethod, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/company/${companyId}/zones/${zoneId}`),
        body: { zone, company_info: companyInfo }
      });
      if (response.success) {
        const { messages, success, zones } = response.result;
        if (success) {
          yield put({
            type: UPDATE_AREA_COVERAGE_SUCCESS,
            zones,
            formMessage: messages,
            lastUpdatedZoneName: zone.name
          });
          successCb();
        } else {
          yield put({ type: UPDATE_AREA_COVERAGE_FAILURE, formMessage: messages });
        }
      }
    } catch (error) {
      console.log('Saga: updateAreaCoverageFlow :', error);
    }
  }
}

export function* getCoverageState() {
  while (true) {
    const request = yield take(GET_COVERAGE_STATE_REQUEST);
    const { countryCode } = request.payload;
    try {
      let response;
      response = yield call(get, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/installer_area_coverage/states?country_code=${countryCode}`)
      });
      const { success, status, result } = response;
      if (success && status === 200) {
        yield put({ type: GET_COVERAGE_STATE_SUCCESS, coverageState: result });
      } else {
        console.log('Saga: coverage state :---');
      }
    } catch (error) {
      console.log('Saga: coverage state :', error);
    }
  }
}
